import CallIcon from '@mui/icons-material/Call';
import SmsIcon from '@mui/icons-material/Sms';

export function HotlineCard({ hotlineInfo }) {
    return (
        <div className="flex flex-col w-full max-w-[900px] bg-light_bg_blue p-4 rounded-xl shadow-md border-2 border-gray-600 mx-auto">
            <div className="w-full flex flex-row items-center justify-between">
                <div className="flex items-center gap-2">
                    <CallIcon className="text-black !w-8 !h-8" />
                </div>
                <div className="text-[22px] font-bold text-black text-center ml-(-10)">
                    {hotlineInfo.name}
                </div>
                <div className="w-8" />
            </div>

            <div className="w-full flex justify-center items-start mt-2">
                <div className="text-[18px] text-black text-center px-2">
                    {hotlineInfo.description}
                </div>
            </div>

            {hotlineInfo.website && (
                <div className="mt-4 text-center">
                    <a
                        href={hotlineInfo.website}
                        className="text-blue-700 underline hover:text-blue-900 text-[18px]"
                    >
                        Website
                    </a>
                </div>
            )}

            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-5">
                <button
                    className="bg-pastel_blue w-full sm:w-[300px] text-white py-2 px-4 rounded-lg font-semibold hover:bg-opacity-60 shadow-md"
                    onClick={(e) => {
                        e.preventDefault();
                        window.location.href = `sms:${hotlineInfo.phoneNumber}`;
                    }}
                >
                     <div className="flex items-center justify-center gap-x-2">
                        <SmsIcon className="!w-5 !h-5 text-white" />
                        <span>Text {hotlineInfo.phoneNumber}</span>
                    </div>
                </button>

                <a
                    href={`tel:${hotlineInfo.phoneNumber}`}
                    className="bg-white outline-2 outline-pastel_blue w-full sm:w-[300px] text-black py-2 px-4 rounded-lg font-semibold hover:bg-opacity-60 flex items-center justify-center shadow-md no-underline"
                >
                    <div className="flex items-center justify-center gap-x-2">
                        <CallIcon className="!w-5 !h-5" />
                        Call {hotlineInfo.phoneNumber}
                    </div>
                </a>
            </div>
        </div>
    );
}
